import {BankAccountLinkDTO} from '../../../ent/models/BankAccountLinkDTO';
import {BankAccountDTO} from '../../../ent/models/BankAccountDTO';
import {BaseDTO} from '../../../common/models/BaseDTO';

export class ClaimDisplayDTO extends BaseDTO {
  transactionId: number;
  batchNumber: string;
  priorAuthorisationNumber: string;
  transactionType: string;
  receiveDate: Date;
  paymentDate: Date;
  encounterStartDate: Date;
  paymentReference: string;
  paymentId: number;
  payTo: string;
  cardNumber: string;
  dependentNo: string;
  insuredPersonId: number;
  insuredPersonName: string;
  insuredPersonBankAccount: BankAccountLinkDTO;
  beneficiaryId: number;
  beneficiaryName: string;
  beneficiaryBankAccount: BankAccountLinkDTO;
  providerId: number;
  providerName: string;
  providerNumber: string;
  providerBankAccount: BankAccountDTO;
  invoiceNumber: string;
  externalTransactionNumber: string;
  referenceNumber: string;
  policyName: string;
  policyNumber: string;
  productId: number;
  productCode: string;
  productName: string;
  caseNumber: number;
  caseDescription: string;
  caseVisible: boolean;
  assessingStatus: string;
  processingStatus: string;
  processingSubClassId: number;
  processingClass: string;
  amountClaimed: number; // a.k.a. claimedAmount
  amountBilled: number; // a.k.a. billedAmount
  benefitAmount: number;
  preAuthorisationAmount: number;
  netAmountForCase: number;
  payAmount: number;
  paidAmount: number;
  casePayments: number;
  isLocked: number;
  isManualPayment: number;
  payerWarning: number;
  familyOfBenefitList: string;
  paidFromBankAccount: string;

  // Used by FE
  details?: {
    claimElapsedDays?: string
    showWarningIcon?: boolean;
    showDangerIcon?: boolean;
    showMissingBankAccountIcon?: boolean;
    showPaymentIcon?: boolean;
  };
}
